import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { lowerCase } from 'lodash';

@Injectable()

export class SettingsService implements OnInit {

    private app: any;
    private layout: any;

    constructor(private http: HttpClient) {
        this.app = {
            name: 'AGAT Laboratories Ltd.',
            year: ((new Date()).getFullYear()),
            copyright: 'Copyright', //�
            description: 'All Rights Reserved.',
            version: 'stg[20230501]'
        };
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };
    }

    ngOnInit() {
    }
    //app
    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    //layout
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }
    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }
    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

}
